import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import FormProvider from "../../../components/hook-form/form-provider";
import { RHFAutocomplete, RHFTextField } from "../../../components/hook-form";
import { LoadingButton } from "@mui/lab";
import { UseFormReturn } from "react-hook-form";
import { IBranch } from "../../../types/branch";
import { IUser } from "../../../types/user";

type Props = {
    open: boolean;
    onClose: VoidFunction;
    methods: UseFormReturn<{
        name: string;
        branch: IBranch;
        manager: Pick<IUser, 'id' | 'name' | 'email'>
    }, any, undefined>,
    onSubmit: VoidFunction;
    isSubmitting: boolean;
    branches: IBranch[];
    users: IUser[];
}

const CreateDepartmentDialogComponent = ({ open, onClose, methods, onSubmit, isSubmitting, branches, users }: Props) => {

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}>Cadastrar Departamento</DialogTitle>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
                    <RHFTextField
                        label="Nome do Departamento"
                        name="name"
                        fullWidth
                        sx={{ mb: 3 }}
                    />
                    <RHFAutocomplete
                        label="Filial"
                        name="branch"
                        options={branches}
                        getOptionLabel={(option: any) => option.code + ' - ' + option.name}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                {option.code + ' - ' + option.name}
                            </li>
                        )}
                        sx={{ mb: 3 }}
                        fullWidth
                        isOptionEqualToValue={(option: IBranch, value: IBranch) => option.id == value.id}
                    />
                    <RHFAutocomplete
                        label="Gerente"
                        name="manager"
                        options={users}
                        getOptionLabel={(option: any) => option.name}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                {option.name}
                            </li>
                        )}
                        fullWidth
                        isOptionEqualToValue={(option: IUser, value: IUser) => option.id == value.id}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        loading={isSubmitting}
                    >
                        Cadastrar Departamento
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );

}

export default CreateDepartmentDialogComponent;